export const animations = {
  focusIndicatorAppear: {
    duration: "200ms",
    timingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
  },
};
